import { get, post, put, del } from '../../../../GlobalModules/Utility/Http'
import {
  getPurchaseOrders,
  getPurchaseOrder,
  createPurchaseOrder,
  updatePurchaseOrder,
  updatePurchaseOrderStatus,
  loadProductsForPO,
  deletePurchaseOrder,
  generateInvoiceFromPO,
  supplierListGet
} from '../Model/PurchaseOrderModel'

export const getPurchaseOrdersApi = async (filters = {}) => {
  try {
    let queryParams = {}

    const filtersObj = {
      limit: filters.limit || 10,
      offset: filters.offset || 0,
      store_id: localStorage.getItem('store_id')
    }

    // Sort mapping
    if (filters.sort && filters.sort.length > 0) {
      filtersObj.sort = filters.sort.map((item) => ({
        field: item.field,
        sort: item.sort
      }))
    }

    // Optional search - only then send filter_op
    if (filters.search && filters.search !== '') {
      queryParams.filter_op = JSON.stringify({ search_attr: 'substring' })
      filtersObj.search_attr = filters.search
    }

    // Optional date range
    if (filters.from_created_date) {
      filtersObj.from_created_date = filters.from_created_date
    }
    if (filters.to_created_date) {
      filtersObj.to_created_date = filters.to_created_date
    }

    queryParams.filters = JSON.stringify(filtersObj)

    const response = await get(
      `${process.env.EXTENDED_URL}purchase_order`,
      queryParams
    )
    const result = getPurchaseOrders(response)
    return result
  } catch (error) {
    throw error
  }
}

export const getPurchaseOrderApi = async (slack) => {
  try {
    const response = await get(
      `${process.env.EXTENDED_URL}purchase_order/${slack}`
    )
    const result = getPurchaseOrder(response)
    return result
  } catch (error) {
    throw error
  }
}

export const createPurchaseOrderApi = async (data) => {
  // Add store_id to the payload only if not already present
  const payload = {
    ...data,
    store_id: data.store_id || localStorage.getItem('store_id')
  }
  console.log('Create Purchase Order Payload:', JSON.stringify(payload, null, 2))
  const response = await post(
    `${process.env.EXTENDED_URL}purchase_order`,
    payload
  )
  return createPurchaseOrder(response)
}

export const updatePurchaseOrderApi = async (slack, data) => {
  try {
    // Don't add store_id for update operation - API doesn't allow it
    // Explicitly remove store_id if present
    const cleanData = { ...data }
    delete cleanData.store_id

    console.log('Update Purchase Order API:', {
      slack,
      originalData: JSON.stringify(data, null, 2),
      cleanData: JSON.stringify(cleanData, null, 2)
    })

    const response = await put(
      `${process.env.EXTENDED_URL}purchase_order/${slack}`,
      cleanData
    )
    const result = updatePurchaseOrder(response)
    return result
  } catch (error) {
    console.error('Update Purchase Order Error:', error)
    throw error
  }
}

// Update purchase order status via controller
export const updatePurchaseOrderStatusApi = async (slack, status) => {
  try {
    const response = await put(
      `${process.env.EXTENDED_URL}purchase_order/status/${slack}`,
      { status }
    )
    return updatePurchaseOrderStatus(response)
  } catch (error) {
    return updatePurchaseOrderStatus(error?.response || {})
  }
}

export const deletePurchaseOrderApi = async (slack) => {
  const response = await del(
    `${process.env.EXTENDED_URL}purchase_order/${slack}`
  )
  return deletePurchaseOrder(response)
}

export const generateInvoiceFromPOApi = async (slack) => {
  const payload = {
    po_slack: slack,
    store_id: localStorage.getItem('store_id')
  }

  const response = await post(
    // `${process.env.EXTENDED_URL}purchase_order/generate_invoice_from_po/${slack}`,
  `${process.env.EXTENDED_URL}purchase_order/generate_invoice_from_po`,
    payload
  )
  return generateInvoiceFromPO(response)
}

export const loadProductsForPOApi = async (keywords, supplier) => {
  try {
    if (!supplier) {
      return loadProductsForPO({
        success: false,
        message: 'Supplier is required',
        data: []
      })
    }

    const trimmed = String(keywords || '').trim()

    // API doesn't allow empty keywords, so use a single space if empty
    const requestBody = {
      keywords: trimmed || ' ',
      // supplier: supplier,
      store_id: localStorage.getItem('store_id')
    }

    const response = await post(
      `${process.env.EXTENDED_URL}common/load_product_for_po`,
      requestBody
    )

    if (response.data && response.data.data) {
      const apiData = response.data.data
      return loadProductsForPO({
        success: true,
        data: apiData,
        message: `Loaded ${apiData.length} products`
      })
    } else if (response.data && Array.isArray(response.data)) {
      return loadProductsForPO({
        success: true,
        data: response.data,
        message: `Loaded ${response.data.length} products`
      })
    } else if (response.data && response.data.success && response.data.data) {
      const apiData = response.data.data
      return loadProductsForPO({
        success: true,
        data: apiData,
        message: `Loaded ${apiData.length} products`
      })
    } else {
      return loadProductsForPO({
        success: false,
        message: response.message || 'No products found',
        data: []
      })
    }
  } catch (error) {
    return loadProductsForPO({
      success: false,
      message: error.response?.data?.message || 'Error loading products',
      data: []
    })
  }
}

export const exportPurchaseOrdersApi = async (data) => {
  try {
    let queryParams = {};

    const requestBody = {
      from_created_date:
        data.from_created_date ||
        new Date(Date.now() - 365 * 24 * 60 * 60 * 1000)
          .toISOString()
          .split('T')[0],
      to_created_date:
        data.to_created_date || new Date().toISOString().split('T')[0]
    }
    if (data.status != null && data.status !== '') {
      requestBody.status = data.status
    }

    requestBody.store_id = localStorage.getItem('store_id')
    requestBody.download = "xlsx";

    queryParams.filters = JSON.stringify(requestBody);

    try {
      const supplierStyleResponse = await get(
        `${process.env.EXTENDED_URL}report/purchase_order`,
        queryParams
      )

      if (
        supplierStyleResponse.data &&
        supplierStyleResponse.data.success &&
        supplierStyleResponse.data.link
      ) {
        if (supplierStyleResponse.data.link.startsWith('data:')) {
          const base64Data = supplierStyleResponse.data.link.split(',')[1]
          const binaryData = atob(base64Data)
          const bytes = new Uint8Array(binaryData.length)
          for (let i = 0; i < binaryData.length; i++) {
            bytes[i] = binaryData.charCodeAt(i)
          }

          return {
            success: true,
            data: bytes.buffer,
            message: 'Export completed - converted from base64',
            filename:
              supplierStyleResponse.data.filename ||
              'purchase_orders_export.xlsx'
          }
        } else {
          return {
            success: true,
            data: supplierStyleResponse.data.link,
            message: 'Export completed - file URL provided',
            isFileUrl: true,
            filename:
              supplierStyleResponse.data.filename ||
              'purchase_orders_export.xlsx'
          }
        }
      }
    } catch (supplierStyleError) {
      // Fallback to standard export
    }

    // Fallback post
    const response = await post(
      `${process.env.EXTENDED_URL}report/purchase_order`,
      requestBody
    )

    // If API returns a link in JSON
    if (response?.data?.success && response?.data?.link) {
      if (String(response.data.link).startsWith('data:')) {
        const base64Data = response.data.link.split(',')[1]
        const binaryData = atob(base64Data)
        const bytes = new Uint8Array(binaryData.length)
        for (let i = 0; i < binaryData.length; i++) {
          bytes[i] = binaryData.charCodeAt(i)
        }
        return {
          success: true,
          data: bytes.buffer,
          message: 'Export completed - converted from base64',
          filename: response.data.filename || 'purchase_orders_export.xlsx'
        }
      }
      return {
        success: true,
        data: response.data.link,
        message: 'Export completed - file URL provided',
        isFileUrl: true,
        filename: response.data.filename || 'purchase_orders_export.xlsx'
      }
    }

    // Otherwise return raw data for caller to blob-ify
    return {
      success: true,
      data: response.data,
      message: 'Export completed'
    }
  } catch (error) {
    console.error('Error exporting purchase orders:', error)
    throw error
  }
}

export const exportPurchaseOrders = async (filters = {}) => {
  try {
    const requestBody = {
      from_created_date:
        filters.from_created_date ||
        new Date(Date.now() - 365 * 24 * 60 * 60 * 1000)
          .toISOString()
          .split('T')[0],
      to_created_date:
        filters.to_created_date || new Date().toISOString().split('T')[0]
    }
    if (filters.status != null && filters.status !== '') {
      requestBody.status = filters.status
    }

    // Use post method from Http utility for consistency
    const response = await post(
      `${process.env.EXTENDED_URL}report/purchase_order`,
      requestBody
    )

    return {
      success: true,
      data: response.data,
      message: 'Export completed'
    }
  } catch (error) {
    console.error('Error exporting purchase orders:', error)
    throw error
  }
}

/**
 * Fetch supplier list with optional filters
 * @param {Object} filters - Filter parameters for the API call
 * @returns {Promise} Processed supplier list data
 */
export const getSupplierList = async (filters = {}) => {
  // Format filters according to the API structure in Postman collection
  let queryParams = {};
  
  if (filters) {
    
      // Handle pagination and sorting
      const filtersObj = {
        status: 1,
        store_id: localStorage.getItem('store_id')
      };
      
      queryParams.filters = JSON.stringify(filtersObj);
  }
  
  const response = await get(`${process.env.EXTENDED_URL}/supplier`, queryParams);
  return supplierListGet(response);
};
export const getSupplierWiseTaxOptionsApi = async (
  supplierId,
  storeId
) => {
  try {
    const endpoint = `${process.env.EXTENDED_URL}/master_tax_option/supplier_wise`;

    const response = await get(
      `${endpoint}?supplier_slack=${supplierId}&store_id=${storeId}`
    );

    const taxData = response?.data?.data || response?.data;

    return {
      success: true,
      data: taxData,
    };
  } catch (error) {
    console.error("Error fetching supplier tax options:", error);

    return {
      success: false,
      data: [],
      message: error?.message || "Failed to fetch tax options",
    };
  }
}

export const getPurchaseOrderAttachmentApi = async (slack) => {
  try {
    const response = await get(`${process.env.EXTENDED_URL}purchase_order/file-download/${slack}`)
    return response?.data || { success: false }
  } catch (error) {
    return { success: false }
  }
}